import { render, staticRenderFns } from "./draft.vue?vue&type=template&id=323c17b0&scoped=true&"
import script from "./draft.vue?vue&type=script&lang=js&"
export * from "./draft.vue?vue&type=script&lang=js&"
import style0 from "./draft.vue?vue&type=style&index=0&id=323c17b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323c17b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('323c17b0')) {
      api.createRecord('323c17b0', component.options)
    } else {
      api.reload('323c17b0', component.options)
    }
    module.hot.accept("./draft.vue?vue&type=template&id=323c17b0&scoped=true&", function () {
      api.rerender('323c17b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/communication/components/draft.vue"
export default component.exports